import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { DnnContextService } from './dnncontext.service';

@Injectable()
export class DnnInterceptor implements HttpInterceptor {

  constructor(private ctx: DnnContextService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const context = this.ctx.getServiceFramework();

    if (context) {
      request = request.clone({
        setHeaders: {
          ModuleId: context.moduleId.toString(),
          TabId: context.tabId.toString(),
          RequestVerificationToken: context.antiForgeryToken,
          'X-Debugging-Hint': 'bootstrapped by bbAngular',
        }
      });
    }

    return next.handle(request);
  }
}